import script from "./ClientsPanelList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientsPanelList.vue?vue&type=script&setup=true&lang=ts"

import "./ClientsPanelList.vue?vue&type=style&index=0&id=a2d02df6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2d02df6"]])

export default __exports__